import React from "react";
import {BaSeLoadingSpinner} from "@base/react";


interface SEButtonExportProps {
    isLoading?: boolean,
    onClick: () => void,
}
export const SEButtonExport: React.FC<SEButtonExportProps> = (
    {
        isLoading,
        onClick
    }
) => {
    return (
        <div
            onClick={onClick}
            style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                border: '1px solid #EBEBF0',
                borderRadius: '4px',
                padding: '8px',
                cursor: 'pointer'
            }}>
            {
                isLoading ? (
                    <BaSeLoadingSpinner diameter={20} description={''} />
                ) : (
                    <i className="ri-download-2-line" style={{color: '#555770', fontSize: 20}}></i>
                )
            }
        </div>
    )
}